<template>
  <div class="mt-2">
    <img :src="troca_top" class="w-full" alt="" />
    <div class="mt-6 mb-2">
      <div class="flex items-start justify-center w-[70%]">
        <img :src="upload2" alt="" class="w-[20px] h-[16px] mr-2" />
        <span class="text-[#FFFFFF] text-[14px] block mt-[-3px]">
          {{ t('Activities.GiftCode.Title') }}
        </span>
      </div>
    </div>

    <div class="w-full flex pt-2">
      <div
        class="w-full flex items-center rounded-lg focus-within:bg-[#2C7952]/70 relative"
      >
        <input
          v-model="code"
          class="text-white flex-1 !text-[15px] placeholder:text-[#fff]/75 h-[44px] rounded-lg bg-[#2D3738] border-none outline-none pl-2"
          :placeholder="t('Activities.GiftCode.Placeholder')"
          type="text"
        />
        <span
          class="absolute right-2 bg-[#fff] text-[11px] text-[#151A1F] font-[600] block w-[42px] h-[26px] text-center leading-[26px] rounded-lg"
          @click="readData"
        >
          {{ t('Activities.GiftCode.Paste') }}
        </span>
      </div>

      <div
        @click="code && onSubmit()"
        :class="[
          'ml-2 flex items-center justify-center text-[16px] font-[600] rounded-xl text-[#151A1F] w-[80px] h-[44px] text-center !bg-[#64F765]',
          { disabled: !code },
        ]"
      >
        {{ t('Activities.GiftCode.Exchange') }}
      </div>
    </div>
    <span class="text-[#fff]/75 mt-1 text-[11px] inline-block">
      {{ t('Activities.GiftCode.PasteTip') }}
    </span>

    <div class="flex flex-col items-center justify-center mt-10 text-[#fff]">
      <div class="w-[297px] bg-[#2C7952]/20 rounded-lg pt-4 px-4">
        <div class="flex justify-center">
          <img :src="i_hui" alt="" class="w-5 h-5 mr-3" />
          <span class="text-[#fff] text-[13px]">
            {{ t('Activities.GiftCode.FollowUs') }}
          </span>
        </div>
        <div class="rounded-lg py-3 px-2 flex items-start justify-between">
          <div
            v-for="item in mediaList"
            :key="item.mediaName"
            @click="handleMedia(item)"
            class="rounded-full w-10 h-10 flex items-center justify-center"
          >
            <img :src="item.imgUrl" class="w-8 h-8" />
          </div>
        </div>
      </div>
    </div>

    <div class="mt-10">
      <ActivityDesc
        class="my-4"
        :title="t('Activities.GiftCode.ActivityDesc')"
        :list="configInfo.activityConfigDesc"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import troca_top from "./images/troca_top.png";
import upload2 from "./images/upload2.png";
import i_hui from "./images/i_hui.png";
import facebook from "./images/facebook_cai.png";
import telegram from "./images/telegram_cai.png";
import whatsapp from "./images/whatsapp.png";
import instagram from "./images/insgram_cai.png";
import ActivityDesc from "@a/components/ActivityDesc/index.vue";
import { formatter } from "@/utils";
import { codeExchange } from "@/api/giftcode";
import { getActivityDetail } from "@/api/activity";
import { useRoute } from "vue-router";
import { useI18n } from 'vue-i18n';
const { t } = useI18n();
const route = useRoute();
const code = ref("");
const configInfo = ref<any>({});
const mediaList = [
  {
    mediaName: "WhatsApp",
    imgUrl: whatsapp,
    goUrl: "https://www.whatsapp.com/channel/0029VaejutjEwEjrZ74old3Q",
  },
  {
    mediaName: "Telegram",
    imgUrl: telegram,
    goUrl: "https://t.me/Agente_9jogos",
  },
  {
    mediaName: "Facebook",
    imgUrl: facebook,
    goUrl: "https://www.facebook.com/profile.php?id=61565981095938",
  },

  {
    mediaName: "Instagram",
    imgUrl: instagram,
    goUrl: "https://www.instagram.com/9jogoscom/",
  },
];

// 查询兑换码活动配置
const getConfigDetail = async () => {
  const { code, data } = await getActivityDetail({
    activityId: route.query.activityId as string,
  });
  if (code == 1) {
    const configJson = data?.configJson ? JSON.parse(data?.configJson) : {};
    const activityConfigDesc = data?.activityConfigDesc
      ? data?.activityConfigDesc?.split("\n")
      : [];
    configInfo.value = { ...data, configJson, activityConfigDesc };
  }
};
const readData = async () => {
  const text: any = await readText();
  code.value = text.replaceAll(" ", "");
};
const onSubmit = async () => {
  const { code: codeStatus, data } = await codeExchange({ value: code.value });
  if (codeStatus === 1) {
    code.value = "";
    showToast({
      icon: "success",
      message: `Troca de R$${formatter().format(data)} bem-sucedida`,
    });
  }
};

onMounted(() => {
  getConfigDetail();
});

const handleMedia = (item: any) => {
  window.open(item.goUrl, "_blank");
};
const readText = async () => {
  try {
    // 尝试读取剪贴板内容
    const text: any = await navigator.clipboard.readText();
    return text;
  } catch (err) {
    console.error("Failed to read clipboard contents: ", err);
    throw err; // 将错误抛出以便调用者处理
  }
};
</script>

<style scoped lang="scss"></style>
